import { http } from './http'

const BASIC_AUTH = 'Basic YWRtaW46R2VubG9naW5AMTIzNTIx'

function defaultDaysByInterval (interval) {
  if (interval === 'week') return 70
  if (interval === 'month') return 300
  return 10 // day
}

export async function getBandwidthHistory (params) {
  const interval = (params && params.interval) ? params.interval : 'day'
  const days = (params && typeof params.days === 'number') ? params.days : defaultDaysByInterval(interval)

  const headers = { Authorization: BASIC_AUTH }

  const res = await http.get('/api/v1/overview/bandwidth-history', {
    params: { interval, days },
    headers
  })
  return res.data
}

export async function getOverviewSummary () {
  const res = await http.get('/api/v1/overview/summary', {
    headers: { Authorization: BASIC_AUTH }
  })
  return res.data
}

export async function getAdminBandwidthSummary () {
  const res = await http.get('/api/admin-bandwidth/summary')
  return res.data
}

export async function getAdminBandwidthSummaryNode () {
  const res = await http.get('/api/admin-bandwidth/summary', {
    params: { group: 'node' }
  })
  return res.data
}

export async function getAdminBandwidthChart (interval) {
  const res = await http.get('/api/admin-bandwidth/chart', {
    params: { interval: interval || 'hour' }
  })
  return res.data
}




// WEBPACK FOOTER //
// ./src/api/overview.js